import DATATABLE_TRANSLATIONS from "./datatable_translations";

export default class ResidentNbsDataTable {
  constructor() {
    $(document).ready(function() {
      showResidentNbsTable();
    });

    $(document).on("turbo:render", function() {
      showResidentNbsTable();
    });

    function showResidentNbsTable() {
      $('#resident-nbs-datatable').dataTable({
        "order": [],
        "columnDefs": [ {
          "targets"  : 'no-sort',
          "orderable": false,
        }],
        "language": DATATABLE_TRANSLATIONS,
        "processing": true,
        "serverSide": true,
        "ajax": {
          "url": $('#resident-nbs-datatable').data('source')
        },
        "pagingType": "full_numbers",
        "columns": [
          {"data": "name"},
          {"data": "actions"}
        ]
        // pagingType is optional, if you want full pagination controls.
        // Check dataTables documentation to learn more about
        // available options.
      });
    }
  }
}
